import React, { PropTypes, Component } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';

/**
 * Copy link button.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
export default class CopyLinkButton extends Component {
  constructor(props) {
    super(props);
    this.state = { copied: false };
    this.handleCopy = this.handleCopy.bind(this);
  }

  handleCopy() {
    this.setState({ copied: true });
    /* revert back to original state after 3s */
    setTimeout(() => this.setState({ copied: false }), 3000);
  }

  render() {
    const { link, className, hideIcon, label } = this.props;
    const { copied } = this.state;

    return (
      <CopyToClipboard text={link} onCopy={this.handleCopy}>
        <button onClick={this.copyToClipboard} className={className}>
          { !hideIcon && <i className={`fa fa-fw fa-${copied ? 'check' : 'link'}`} /> }
          {' '}
          { copied ? 'Copied!' : label || 'Copy link' }
        </button>
      </CopyToClipboard>);
  }
}

/*
 * PropTypes.
 *
 * @property {string} link - link to be copied
 * @property {string} className - button CSS classes
 * @property {string} label - button label
 * @property {bool} hideIcon - whether to hide button icon
 */
CopyLinkButton.propTypes = {
  link: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string,
  hideIcon: PropTypes.bool,
};
